<template>
  <svg
    :height="size"
    :width="size"
    fill="none"
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      :fill="fill"
      d="M25.23 22.44V13.23C25.23 8.62002 22.14 4.54002 17.7 3.29002V2.71002C17.7 1.23002 16.5 0.0200195 15.02 0.0200195H14.99C13.51 0.0200195 12.3 1.23002 12.3 2.71002V3.24002C7.74997 4.43002 4.57997 8.53002 4.57997 13.24V22.56C3.42997 23.27 2.71997 24.54 2.71997 25.87C2.71997 26.05 2.78997 26.22 2.91997 26.35C3.04997 26.48 3.21997 26.55 3.39997 26.55H11.82V26.79C11.82 28.54 13.24 29.97 15 29.97C16.76 29.97 18.18 28.55 18.18 26.79V26.55H26.61C26.99 26.55 27.29 26.24 27.29 25.87C27.29 24.47 26.49 23.13 25.24 22.45L25.23 22.44ZM16.81 26.78C16.81 27.78 16 28.59 15 28.59C14 28.59 13.19 27.78 13.19 26.78V26.54H16.82V26.78H16.81ZM16.93 22.95C16.93 22.57 16.62 22.27 16.25 22.27H5.93997V13.23C5.93997 8.29002 9.95997 4.26002 14.91 4.26002C19.86 4.26002 23.88 8.28002 23.88 13.23V22.87C23.88 23.15 24.05 23.4 24.31 23.5C25.05 23.79 25.61 24.42 25.83 25.18H4.16997C4.35997 24.52 4.80997 23.96 5.41997 23.63H16.24C16.62 23.63 16.92 23.32 16.92 22.95H16.93ZM13.66 2.71002C13.66 1.98002 14.26 1.38002 14.99 1.38002H15.02C15.75 1.38002 16.35 1.98002 16.35 2.71002V2.91002H13.66V2.71002V2.71002Z"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { iconProps } from '../../IconProps'

export default defineComponent({
  name: 'IconBell',
  props: {
    ...iconProps,
  },
})
</script>
